import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { apiClient } from 'lib/api';
import type { QueryConfig } from 'lib/react-query';
import queryKeys from './queryKeys';
import type { TwitterAccountEntry } from './types';

export interface GetTwitterAccountsParams {
  app: string;
}

export const getTwitterAccounts = async (
  { params }: { params: GetTwitterAccountsParams },
  signal?: AbortSignal,
): Promise<TwitterAccountEntry[]> => {
  const res = await apiClient.get<TwitterAccountEntry[]>(queryKeys.accounts, {
    params,
    signal,
  });

  if (isAxiosError(res)) {
    const error = new Error('Get X Ad Accounts Failed');
    error.cause = res.response?.data;
    return Promise.reject(error);
  }

  return res.data;
};

interface UseTwitterAccountsOptions<TData> {
  params: GetTwitterAccountsParams;
  config?: QueryConfig<typeof getTwitterAccounts, TData>;
}

export const useTwitterAccounts = <TData = TwitterAccountEntry[]>({
  params,
  config,
}: UseTwitterAccountsOptions<TData>) =>
  useQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getTwitterAccounts({ params }, signal),
    queryKey: [queryKeys.accounts, params],
  });
